import React from "react";
import ENV from "app/utils/ENV";
import { View, ActivityIndicator } from "react-native";
import storageActions from "app/utils/storageActions";
import Text from "app/components/Text";
import TextInput from "app/components/TextInput";
import { StyleContext } from "app/contexts/Style";
import colorHelpers from "app/utils/colorHelpers";
import {
  KeyboardAccessoryNavigation,
  KeyboardAccessoryView,
} from "react-native-keyboard-accessory";

import MomentComposer from "app/components/chapter/MomentComposer";

export default class GlobalComposer extends React.Component {
  static contextType = StyleContext;
  constructor(props, context) {
    super(props);
    this.state = {
      loading: true,
      fetching: false,
      text: "",
      height: context.sizes.COMPOSER_HEIGHT,
    };
    this.isFocused = false;
  }

  async componentDidMount() {
    // let text = await storageActions.fetchItem("global_composer_text", "");
    let text = "";
    this.setState({ text, loading: false });
  }

  render() {
    let { loading, text, height } = this.state;
    if (ENV.WEB || loading) return null;
    if (loading) return null;

    return (
      <KeyboardAccessoryView androidAdjustResize alwaysVisible hideBorder>
        {({ isKeyboardVisible }) => {
          if (isKeyboardVisible && !this.isFocused) {
            return null;
          }
          return (
            <View
              style={{
                height: height,
                backgroundColor: this.context.colors.fill,
                padding: this.context.sizes.large,
              }}
            >
              {true ? (
                <View
                // style={{ borderWidth: 1, borderColor: "white", flex: -1 }}
                >
                  <MomentComposer
                    noIcon
                    text={text}
                    placeholder={"Make a note"}
                    placeholderTextColor={colorHelpers.hexToRgbaString(
                      this.context.colors.foreground,
                      0.4
                    )}
                    onFocus={() => {
                      this.isFocused = true;
                    }}
                    onBlur={() => {
                      setTimeout(() => {
                        this.isFocused = false;
                      }, 100);
                    }}
                    chapter={{ id: "today" }}
                    onChangeText={(text) => {
                      storageActions.saveItem("global_composer_text", text);
                    }}
                    onChangeHeight={(height) => {
                      console.log("change height", height);
                      let newHeight = Math.max(
                        this.context.sizes.COMPOSER_HEIGHT,
                        height + 40
                      );
                      this.setState({ height: newHeight });
                    }}
                  />
                </View>
              ) : (
                <TextInput
                  inputRef={(c) => (this.composerRef = c)}
                  multiline
                  autoHeight
                  placeholderTextColor={colorHelpers.hexToRgbaString(
                    this.context.colors.foreground,
                    0.4
                  )}
                  placeholder={"Make a note"}
                  style={[
                    this.styles().textInput,
                    {
                      backgroundColor: this.context.colors.fill,
                      // padding: this.context.sizes.giant,
                      // height: 100,
                      // flex: 1,
                      minHeight:
                        this.context.sizes.COMPOSER_HEIGHT -
                        this.context.sizes.large * 2,
                    },
                  ]}
                  onChangeText={(composerText) => {
                    this.setState({ composerText });
                  }}
                  onFocus={() => {
                    this.isFocused = true;
                  }}
                  onBlur={() => {
                    setTimeout(() => {
                      this.isFocused = false;
                    }, 100);
                  }}
                  // hideCaret && { caretColor: "transparent" },
                >
                  {text}
                </TextInput>
              )}
            </View>
          );
        }}
      </KeyboardAccessoryView>
    );
  }

  toggleExpanded = (id) => {
    let { expandedIds } = this.state;
    if (expandedIds.includes(id)) {
      expandedIds.splice(expandedIds.indexOf(id), 1);
    } else {
      expandedIds.push(id);
    }
    this.setState({ expandedIds });
  };

  handleZoomOut = () => {
    this.setState({ hiddenLevels: this.state.hiddenLevels - 1 });
  };

  handleZoomIn = () => {
    this.setState({ hiddenLevels: this.state.hiddenLevels + 1 });
  };

  focusNext = async (
    id,
    expanded,
    peers,
    index,
    children,
    uncles,
    parentIndex
  ) => {
    console.log("focus next");
    let nextId;
    if (expanded && children.length) {
      // first child
      nextId = children[0].id;
    } else if (peers.length && peers.length - 1 > index) {
      // next peer
      nextId = peers[index + 1].id;
    } else {
      // next uncle
      nextId = uncles[parentIndex + 1]?.id;
    }
    if (nextId && this[`ref-${nextId}`]) {
      let ref = this[`ref-${nextId}`];
      if (!!ref?.focus) {
        // ref.addEventListener('focus', this.cursorToBeginning)
        await this.setState({ hideCaret: true });
        ref.focus();
        await new Promise((resolve) => setTimeout(resolve, 0));
        !!ref?.setSelectionRange && ref.setSelectionRange(0, 0);
        await this.setState({ hideCaret: false });
        // ref.removeEventListener('focus', this.cursorToBeginning)
      }
    } else {
      console.log("not found", nextId, this.refs);
    }
  };

  cursorToBeginning = (event) => {
    console.log(
      "listener",
      event?.target?.setSelectionRange,
      event?.srcElement?.setSelectionRange
    );
    let ref = event?.target;
    ref?.setSelectionRange && ref.setSelectionRange(0, 0);
    ref?.setSelectionRange
      ? console.log("cursor to beginning")
      : console.log("no ref found");
  };

  focusPrevious = (id, peers, index, parent) => {
    console.log("focus previous");
    let prevId;
    if (peers.length && index > 0) {
      // prev peer
      prevId = peers[index - 1].id;
    } else {
      // parent
      prevId = parent.id;
    }
    if (prevId && this[`ref-${prevId}`]) {
      console.log(prevId, this[prevId]);
      this[`ref-${prevId}`].focus && this[`ref-${prevId}`].focus();
    } else {
      console.log("not found", prevId, this.refs);
    }
  };

  styles = () => ({
    container: {
      flex: 1,
    },
  });
}
